
import { PostcodeDataResponce } from '@/models/main';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { notificationErrorText } from '@/utils/PortalConstants';

@Component({})
export default class LookupPostcode extends Vue {
  @Prop({ type: Function, required: true }) private autocomplete!: (
    postcode: string,
  ) => Promise<PostcodeDataResponce[]>;

  private input = '';
  private inputVal = '';
  private itemSearch: PostcodeDataResponce[] = [];
  private loading = false;

  private keydown(event) {
    // Only numbers, Backspace, Delete & Arrows
    const numberPattern = /\d+/g;
    const valueValid = event.key.match(numberPattern);
    if (
      !valueValid &&
      event.code !== 'Backspace' &&
      event.code !== 'Delete' &&
      event.code !== 'ArrowLeft' &&
      event.code !== 'ArrowRight'
    ) {
      event.preventDefault();
    }
  }

  private search(val: string) {
    if (val === this.input) {
      return;
    }
    this.inputVal = val;
    if (val?.length >= 2) {
      this.itemSearch = [];
      this.loading = true;
      this.autocomplete(val)
        .then((data: PostcodeDataResponce[]) => {
          this.itemSearch = data;
        })
        .catch(() => {
          this.$notify({
            group: 'network',
            title: 'Error searching the postcode',
            text: notificationErrorText,
            type: 'warn',
            duration: 3000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  private change(val) {
    this.input = val;
    this.$emit('change', val);
  }
}
